<template>
    <div class="monitor">
        <!-- 图标-->

        <!-- 图标二 -->
        <el-row :gutter="30">
            <el-col :xs="24" :sm="24" :md="11" :lg="7" :xl="7">
                 <InformationList />
                <el-row class="monitor-header-two" :gutter="20" style="margin-bottom: 20px;">
                    <el-col :span="24">
                        <div class="monitor-cart-name">
                            <div class="monitor-cart-name-left"> 
                                Top 10 Plumbers（Pressure Test Quantities）
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        
                        <ve-histogram :data="plumbersData"></ve-histogram>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="13" :lg="17" :xl="17">
                <el-row class="monitor-header-two" :gutter="20">
                    <el-col :span="24">
                        <div class="monitor-cart-name">
                            <div class="monitor-cart-name-left">
                                Analysis of Pressure Test Quantities
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="monitor-subtext-name">
                                Quantities of Pressure Test this year : {{currentTestTotal}} , Growth rate : {{testYearRate}}
                        </div>
                        <div class="monitor-visitors monitor-visitors-scale">
                            <div class="monitor-visitors-left">
                                <ve-histogram :data="testData1"></ve-histogram>
                                
                            </div>
                            <div class="monitor-visitors-right">
                                <ve-pie :data="testData2" :colors="colors"></ve-pie>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                
            </el-col>
        </el-row>
    </div>
</template>

<script>
import InformationList from '../../components/analyze/InformationList'
import Maps from '../../components/analyze/map'
import countTo from 'vue-count-to';

export default {
    data(){
        return {
            value1:'',
            config:{
                data: [66],
                shape: 'roundRect'
            },
            plumbersData:{
                columns: ['name', 'num'],
                rows:[]
                // rows: [
                //     { 'name': 'Moon', 'num': 1393 },
                //     { 'name': 'Jack', 'num': 1130 },
                //     { 'name': 'Wendy', 'num': 1023 },
                //     { 'name': 'Tommy', 'num': 1003 },
                //     { 'name': 'Frake', 'num': 992 },
                //     { 'name': 'Sam', 'num': 893 },
                //     { 'name': 'Mike', 'num': 793 },
                //     { 'name': 'Yoyo', 'num': 752 },
                //     { 'name': 'Adem', 'num': 593 },
                //     { 'name': 'Raymond', 'num': 459 }
                // ]
            },
            colors : ['#1AA2FC','#F85E1F', '#25D9B4'],
            currentTestTotal:null,
            testYearRate:null,
            testData2: {
                columns: ['key', 'val'],
                rows:[]
                // rows: [
                //     { 'key': 'Testing', 'val': Math.random()*200 },
                //     { 'key': 'Fail', 'val': Math.random()*100 },
                //     { 'key': 'Pass', 'val': Math.random()*5000 }
                // ]
            },
            testData1:{
                columns: ['mon', 'Pass', 'Fail','Testing'],
                rows:[]
                // rows: [
                //     { 'mon': 'Jan', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'Feb', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'Mar', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'Apr', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'May', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'June', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'july', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'Aug', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'Sept', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'Oct', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'Nov', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                //     { 'mon': 'Dec', 'Pass': Math.random()*500, 'Fail': Math.random()*500, 'Testing': Math.random()*500},
                // ]
            },
        }
    },
    components:{
        InformationList,
         Maps,
        countTo
    },
    created(){

        this.getTestRecords()
        this.getTestRecordsByResult()
        this.getTopPlumbs()
    },
    methods:{
          //获取 Quantities of Pressure Test数据
        getTestRecords() {
            this.$get(`index/getTestRecords`).then(
                ({ data: res }) => {
                    // console.log('getTestRecords',res.data)
                    this.testData1.rows=res.data.list
                    this.currentTestTotal = res.data.currentYearTotal
                    this.testYearRate = res.data.rate
                }
            )
        },
        //获取 Quantities of Pressure Test数据
        getTestRecordsByResult() {
            this.$get(`index/getTestRecordsByResult`).then(
                ({ data: res }) => {
                    // console.log('getTestRecordsByResult',res.data)
                    this.testData2.rows=res.data.list
                }
            )
        },
        //获取 Quantities of Pressure Test数据
        getTopPlumbs() {
            this.$get(`index/getTopPlumbs`).then(
                ({ data: res }) => {
                    // console.log('getTopPlumbs',res.data)
                    this.plumbersData.rows=res.data
                }
            )
        },
    }
}
</script>

<style scoped>
.monitor{
    background: #F5F7F9;
    padding: 10px 25px;
    box-sizing: border-box;
    width: 100%;
    min-height: 100%;
}
.monitor-header{
    border: 1px solid #E6E6E6;
    background: #ffffff;
    border-radius: 5px;
    margin-bottom: 20px;
}
.monitor-header-two{
    border: 1px solid #E6E6E6;
    background: #ffffff;
    border-radius: 5px;
    margin-bottom: 20px;
}
.monitor-header-info{
    background: #ffffff;
}
.monitor-info-name{
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #E6E6E6;
    display: flex;
    justify-content: space-between;
}
.monitor-cart-name{
    width: 100%;
    height: 50px;
    margin-bottom: 20px;
    border-bottom: 1px solid #E6E6E6;
    display: flex;
    justify-content: space-between;
}
.monitor-subtext-name{
    width: 100%;
    height: 20px;
    margin-top: 0px;
    display: flex;
    justify-content: space-between;
    color: #5C5C5C;
    font-size: 14px;
}
.monitor-cart-name-left{
    width: 320px;
    height: 100%;
    /* background: blueviolet; */
    line-height: 42px;
    color: #5C5C5C;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
}
.monitor-cart-name-left-icon{
    width: 30px;
    height: 30px;
    background: #F7EEFF;
    border-radius: 2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
}
.monitor-cart-name-left-icon-s{
    width: 20px;
    height: 20px;
    color: blueviolet;
    fill: currentColor;
}
.monitor-cart-name-right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.monitor-cart-name-right-list{
    width: 60px;
    height: 50px;
    /* background: chartreuse; */
    text-align: center;
    line-height: 50px;
    color: #515A6E;
    font-size: 14px;
    cursor: pointer;
}
.monitor-cart-name-right-list:hover{
    color: #2D8CF0;
}
.monitor-cart-box{
    /*background: chocolate;*/
    width: 100%;
    height: 100px;
    padding: 10px 5px;
    box-sizing: border-box;
    /* border: 1px solid #E6E6E6; */
    background: #ffffff;
    border-radius: 5px;
    margin-bottom: 20px;
}
.monitor-cart-probability{
    background: cornflowerblue; 
    width: 100%;
    height: 210px;
    padding: 20px 15px 0px;
    box-sizing: border-box;
}
.monitor-cart-probability-box{
    width: 100%;
    height: 80%;
    /* border: 1px solid #515A6E; */
    border-radius: 5px;
}
.monitor-cart-probability-name{
    width: 100%;
    height: 20%;
    text-align: center;
    line-height: 34px;
    /* background: chartreuse; */
    color: #515A6E;
    font-size: 14px;
    cursor: pointer;
}
.monitor-visitors{
    width: 100%;
    height: 400px;
}
.monitor-visitors-scale{
    display: flex;
    justify-content: space-between;
}
.monitor-visitors-left{
    width: 70%;
    height: 100%;
}
.monitor-visitors-right{
    width: 30%;
    height: 100%;
    /* background: chocolate; */
    padding: 20px;
    box-sizing: border-box;
}
.monitor-visitors-right-list{
    width: 100%;
    height: 40px;
    /* background: cyan; */
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.monitor-visitors-right-list-icon{
    width: 15px;
    height: 15px;
    color: #666666;
    fill: currentColor;
}
.monitor-visitors-right-list-name{
    width: 180px;
    /* background: darkgoldenrod; */
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #595959;
    padding-left: 10px;
    box-sizing: border-box;
    word-wrap:break-word;
}
.monitor-visitors-right-list-number{
    flex: 1;
    /* background: yellowgreen; */
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #8C8C8C;
    padding-left: 10px;
    box-sizing: border-box;
    text-align: right;
    padding-right: 15px;
    word-wrap:break-word;
}

.monitor-visitors-left-list{
    width: 100%;
    height: 40px;
    /* background: cyan; */
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.monitor-visitors-left-list-icon{
    width: 15px;
    height: 15px;
    color: #666666;
    fill: currentColor;
}
.monitor-visitors-left-list-name{
    width: 250px;
    /* background: darkgoldenrod; */
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #595959;
    padding-left: 10px;
    box-sizing: border-box;
    word-wrap:break-word;
}
.monitor-visitors-left-list-number{
    flex: 1;
    /* background: yellowgreen; */
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #8C8C8C;
    padding-left: 10px;
    box-sizing: border-box;
    text-align: right;
    padding-right: 15px;
    word-wrap:break-word;
}

.monitor-header-users{
    width: 100%;
    height: auto;
    padding: 0px 10px;
    box-sizing: border-box;
}
.monitor-header-users-time{
    width: 100%;
    height: 40px;
    line-height: 20px;
    font-size: 12px;
    color: #515A6E;
    text-align: left;
    margin-bottom: 10px;
}
.monitor-header-users-number{
    width: 100%;
    height: 58px;
    text-align: center;
    font-size: 40px;
    line-height: 58px;
    color: #515A6E;
    font-weight: bold;
}
.monitor-header-users-message{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #515A6E;
    text-align: center;
}
/* 用户数 */
.monitor-header-users-icon{
    width: 100%;
    height: 50px;
    text-align: center;
    /* background: chocolate; */
    display: flex;
    justify-content: center;
    align-items: center;
}
.monitor-header-users-icon-s{
    width: 36px;
    height: 36px;
    fill: currentColor;
    color: #2399FA;
}
/* 评论 */
.monitor-header-comment{
    width: 100%;
    height: auto;
}
.monitor-header-comment .monitor-header-comment-list:nth-last-child(1){
    border-bottom-color: transparent;
}
.monitor-header-comment-list{
    width: 100%;
    height: 120px;
    display: flex;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EAEC;
}
.monitor-header-comment-list-li{
    width: 33%;
    height: 120px;
}
.monitor-header-comment-list-li-number{
    font-weight: bold;
    font-size: 30px;
    color: #515A6E;
    line-height: 120px;
    text-align: center;
}
.monitor-header-comment-list-li-icon{
    width: 50px;
    height: 50px;
    color: #FBD971;
    fill: currentColor;
}
.monitor-header-comment-list-li-tag{
    display: flex;
    /* background: cyan; */
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.monitor-header-comment-list-li-tag-text{
    width: 100%;
    height: 35px;
    text-align: center;
    line-height: 35px;
    color: #808695;
    font-size: 14px;
}
.monitor-header-comment-list-li-percentage{
    height: 100%;
    line-height: 120px;
    color: #36C17B;
    font-size: 18px;
    text-align: center;
}
</style>